<template>
    <div component="HomeDetail" :scene="scene">
        <router-view name="subpage" view="subpage"></router-view>
        <div block="main">
            <slot name="main"></slot>
        </div>
        <!-- <div block="right">
            <slot name="right"></slot>
        </div> -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
//import Velocity from 'velocity-animate';

export default {
    name: 'HomeDetail',

    components: {
        // HomeMenu
    },

    props: {
        scene: {
            type: String,
            required: false,
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='HomeDetail'] {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: 520px) {
        // flex-direction: row;
        max-width: 440px;
    }

    &[scene='subpage'] {
        width: 80%;

        @media (min-width: 520px) {
            width: 170px;
        }

        [block='main'] {
            left: -200%;
            position: absolute;
        }

        // [block='right'] {
        //     width: 100%;
        //     margin-top: 0;

        //     @media (min-width: 520px) {
        //         width: 150px;
        //         right: calc(100% - 150px);
        //     }
        // }
    }

    &[view='subpage'] {
        // overflow: hidden;
        // border-radius: 20px;
    }
}

[component='HomeDetail'] [block='main'] {
    width: 100%;
    transition: 1s;
    left: 0;
    position: relative;
    min-width: 300px;

    a {
        color: @black;
        // text-decoration: underline;

        &:hover {
            color: @primary_dk;
        }
    }

    // @media (min-width: 520px) {
    //     width: calc(100% - 150px);
    //     padding-right: 30px;
    // }
}

// [component='HomeDetail'] [block='right'] {
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     transition: 1s;

//     @media (min-width: 520px) {
//         width: 150px;
//         position: absolute;
//         right: 0%;
//         padding: 20px 0 0 20px;
//         margin-top: 40px;
//         border: 2px solid black;
//         border-width: 2px 0px 0px 2px;
//         border-radius: 30px 0 0 0px;
//     }

//     h4,
//     h3,
//     h2 {
//         margin: 0;
//         line-height: 1.4;
//     }

//     [block='buttons'] {
//         .flex-center;
//         // justify-content: space-between;

//         @media (min-width: 520px) {
//             width: 130px;
//             flex-direction: column;

//         }

//         [component='NavButton'] {
//             margin-bottom: 20px;
//         }
//     }

//     .close {
//         position: fixed;
//         top: 0;
//         right: 0;
//         z-index: 7;
//     }

// }

// STAV

[component='HomeDetail'][state=''] {
}

// TAG

[component='HomeDetail'][tag=''] {
}
</style>
